import { AlertCircle, RefreshCw, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

interface MaintenanceScreenProps {
  onRetry?: () => void;
}

const MaintenanceScreen = ({ onRetry }: MaintenanceScreenProps) => {
  const handleRetry = () => {
    window.location.reload();
    if (onRetry) {
      onRetry();
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="max-w-md w-full p-8 space-y-6 text-center">
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center">
            <AlertCircle className="w-10 h-10 text-destructive" />
          </div>
        </div>
        
        <div className="space-y-2">
          <h1 className="text-2xl font-bold">We're fixing things</h1>
          <p className="text-muted-foreground">
            We're experiencing some technical difficulties. Our team is working to resolve the issue.
          </p>
        </div>

        <div className="flex items-start gap-3 p-4 bg-muted/50 rounded-lg text-left">
          <WifiOff className="w-5 h-5 text-muted-foreground mt-0.5 flex-shrink-0" />
          <div className="space-y-1 text-sm">
            <p className="font-medium">What might be happening:</p>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>Connection issues with our servers</li>
              <li>Temporary service maintenance</li>
              <li>Network connectivity problems</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <Button onClick={handleRetry} className="w-full" size="lg">
            <RefreshCw className="w-4 h-4 mr-2" />
            Try Again
          </Button>
          <Button 
            variant="outline" 
            onClick={() => window.location.href = '/login'}
            className="w-full"
          >
            Return to Login
          </Button>
        </div>

        <p className="text-xs text-muted-foreground">
          If the problem persists, please contact support at{" "}
          <a 
            href="mailto:punit@flowlabs.live,marcus@flowlabs.live" 
            className="text-primary hover:underline"
          >
            support@flowlabs.live
          </a>
        </p>
      </Card>
    </div>
  );
};

export default MaintenanceScreen;

